export default __webpack_public_path__ + "static/media/bg_logo_bank.34e33efe.png";